(function () {
    $(".js-m-input-password").each(function () {
        $(this).find('.js-m-input-password-btn').on('click', function (event) {
            event.preventDefault();

            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden').addClass('is-visible');
                $(this).siblings('input').attr('type', 'text');

            }
            else {
                $(this).removeClass('is-visible').addClass('is-hidden');
                $(this).siblings('input').attr('type', 'password');

            }
        });
    });

})();
